import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from '@angular/core'
import { getQrCodeAsSvg } from '@lemon/core-firebase/qrcode/svg'
@Component({
  selector: '[lemon-qrcode]',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QrcodeComponent implements OnChanges {
  @Input() qrcodeValue: string

  constructor(private _elementRef: ElementRef<HTMLElement>) {}

  ngOnChanges() {
    this.createBarcode()
  }

  async createBarcode() {
    if (!this.qrcodeValue) {
      return
    }

    const qrcode = await getQrCodeAsSvg(this.qrcodeValue, {
      bgColor: 'white',
      color: 'black',
      ecLevel: 'M',
      margin: 0,
    })

    this._elementRef.nativeElement.innerHTML = qrcode
  }
}
